namespace SPA {
	export namespace Contacts {

		export class Detail extends ui.tab.TabHTMLPresentation
		{
			private Contact: SPA.Contact;

			private m_Parent: JQuery;

			private ObjectList: SPA.Realtor.ObjectList;
			private Events: Backbone.Events;

			public constructor(data: SPA.Contact)
			{
				super();

				this.m_Parent = ui.$$.div();
				this.Contact = data;
				this.ObjectList = app.getObjectManager().getList();
				this.Events = Backbone.Events;
				// this.Events.listenTo(this.Contact, 'all', (...args) => console.log(args));
			}

			public rebuild(root: ui.base.BaseHTMLElement | JQuery<HTMLElement>): Detail
			{
				root.empty();

				const detailView = new DetailView({model: this.Contact});
				const basicDiv = ui.$$.div().addClass('contact-details').empty();

				basicDiv.appendTo(root instanceof ui.base.BaseHTMLElement ? root.Root() : root);
				basicDiv.append(detailView.render().el);
				// basicDiv.append(this.buildContact(this.data));
				basicDiv.append(this.buildTabs(this.Contact));
				return this;
			}

			private buildTabs(contact: SPA.Contact): JQuery
			{
				const navTabs = ui.$$.ul().addClass('nav nav-tabs');
				const navContent = ui.$$.div().addClass('tab-content address-objects container-fluid');

				// Kaufobjekt hinzufügen
				const addBidderInput = $('<input type="text" class="form-control" placeholder="Objektbestand durchsuchen" value="" />');
				addBidderInput.autocomplete({
					source: (request: any, response: any) => {
						const term = request.term.toLowerCase();
						const list = app.getObjectManager().getList().models;

						const matches: any[] = [];
						_.each(list, (object, index) => {
							if (object.Address.display.toLowerCase().indexOf(term) !== -1) {
								matches.push({
									data: object,
									value: "",
									label: object.ObjectNumber + ': ' + object.Address.display
								});
							}
						});
						response(matches);
					},
					minLength: 2,
					select: (event, ui) => {
						// Clear the input field
						(event.target as HTMLInputElement).value = "";

						const object: SPA.Realtor.RealtorObjectModel = ui.item.data;

						// Immediately save the new bidder
						contact.link(object.ObjectNumber, 'bidder', (data: ContactStatus) =>
						{
							const statusRowView = new SPA.Contacts.StatusRowView({model: data});
							const statusRow = statusRowView.render().$el;
							$('#bid-result-contact-' + contact.ContactID).append(statusRow);
						});

						return false;
					}
				});

				const ownerResultAnchor = ui.$$.div().attr('id', 'seller-result-contact-' + contact.ContactID);
				const ownerList = contact.StatusList.owner();
				if (ownerList && ownerList.length !== 0) {
					for (const otype of ownerList)
					{
							const statusRowView = new SPA.Contacts.StatusRowView({model: otype});
							const statusRow = statusRowView.render().$el;
							ownerResultAnchor.append(statusRow);
					}
				}

				const sellerResultAnchor = ui.$$.div().attr('id', 'seller-result-contact-' + contact.ContactID);
				const sellerList = contact.StatusList.seller();
				if (sellerList && sellerList.length !== 0) {
					for (const otype of sellerList)
					{
							const statusRowView = new SPA.Contacts.StatusRowView({model: otype});
							const statusRow = statusRowView.render().$el;
							sellerResultAnchor.append(statusRow);
					}
				}

				const bidderResultAnchor = ui.$$.div().attr('id', 'bid-result-contact-' + contact.ContactID);
				const bidderList = contact.StatusList.bidder();
				if (bidderList && bidderList.length !== 0) {
					for (const otype of bidderList) {
						const statusRowView = new SPA.Contacts.StatusRowView({model: otype});
						const statusRow = statusRowView.render().$el;
						bidderResultAnchor.append(statusRow);
					}
				}

				const submitBtnBottom = ui.$$.button()
					.addClass('btn btn-success btn-save btn-save-top')
					.on('click', {contact}, (e) => {
						this.onDemandFormSave(e);
					})
					.append('<i class="fas fa-save"></i><span> Bedarfsanalyse speichern</span>');

				if (sellerList.length !== 0)
				{
					const sellerTab = ui.$$.a().attr({
						'data-toggle': 'tab',
						'href': '#seller-list-contact-' + contact.ContactID
					}).text('Objekt-Verkäufer von');
					navTabs.append(ui.$$.li().append(sellerTab));

					const sellerContent = ui.$$.div().attr('id', 'seller-list-contact-' + contact.ContactID).addClass('tab-pane fade')
						.append('<h2>Objekt-Verkäufer von</h2>')
						.append(sellerResultAnchor);
					navContent.append(sellerContent);
				}

				if (ownerList.length !== 0)
				{
					const ownerTab = ui.$$.a().attr({
						'data-toggle': 'tab',
						'href': '#owner-list-contact-' + contact.ContactID
					}).text('Objekt-Eigentümer von');
					navTabs.append(ui.$$.li().append(ownerTab));

					const ownerContent = ui.$$.div().attr('id', 'owner-list-contact-' + contact.ContactID).addClass('tab-pane fade')
						.append('<h2>Objekt-Eigentümer von</h2>')
						.append(ownerResultAnchor);
					navContent.append(ownerContent);
				}

				// Keep showing demand and self info once data was entered
				if ((bidderList.length !== 0))
				{
					const bidderContent = ui.$$.div().attr('id', 'bid-list-contact-' + contact.ContactID).addClass('tab-pane fade')
						.append('<h2>Kaufinteressent für</h2>')
						.append('<p>Fügen Sie diesem Kontakt über die Suche ein potenzielles Kaufobjekt hinzu.</p>')
						.append(addBidderInput)
						.append(bidderResultAnchor);
					const bidderTab = ui.$$.a().attr({
						'data-toggle': 'tab',
						'href': '#bid-list-contact-' + contact.ContactID
					}).text('Kaufinteressent für')
						.on('show.bs.tab', (e) => {
							$('#bid-list-contact-' + contact.ContactID).replaceWith(bidderContent);
						});
					navTabs.append(ui.$$.li().append(bidderTab));
					navContent.append(bidderContent);

					const selfInfoView = new SelfinfoView({model: this.Contact, asForm: true});
					const selfinfoTab = ui.$$.a().attr({
						'data-toggle': 'tab',
						'href': '#selfinfo-list-contact-' + contact.ContactID
					}).text('Selbstauskunft')
						.on('show.bs.tab', (e) => {
							$('#selfinfo-list-contact-' + contact.ContactID).empty()
								.append(selfInfoView.render().el);
						});
					navTabs.append(ui.$$.li().append(selfinfoTab));
					navContent.append(ui.$$.div().attr('id', 'selfinfo-list-contact-' + contact.ContactID).addClass('tab-pane fade'));

					const demandTab = ui.$$.a().attr({
						'data-toggle': 'tab',
						'href': '#demand-list-contact-' + contact.ContactID
					}).text('Bedarfsanalyse')
						.on('show.bs.tab', (e) => {
							$('#demand-list-contact-' + contact.ContactID).empty()
								.append(this.buildDemandForm(contact || {}))
								.append(submitBtnBottom);
						});
					navTabs.append(ui.$$.li().append(demandTab));
					navContent.append(ui.$$.div().attr('id', 'demand-list-contact-' + contact.ContactID).addClass('tab-pane fade'));
				}
				const customer = contact.StatusList.customer();
				// Add Demand Tab for customer
				if ((customer.length !== 0) && bidderList.length === 0) {
					const demandTab = ui.$$.a().attr({
						'data-toggle': 'tab',
						'href': '#demand-list-contact-' + contact.ContactID
					}).text('Bedarfsanalyse');
					navContent.append(ui.$$.div().attr('id', 'demand-list-contact-' + contact.ContactID).addClass('tab-pane fade'));
					if (ownerList.length !== 0 || sellerList.length !== 0) {
						demandTab.on('show.bs.tab', (e) => {
							$('#demand-list-contact-' + contact.ContactID).empty()
								.append(this.buildDemandForm(contact || {}))
								.append(submitBtnBottom);
						});
					} else {
						navContent
							.append(ui.$$.div().attr('id', 'demand-list-contact-' + contact.ContactID).addClass('tab-pane fade'))
							.append(this.buildDemandForm(contact || {}))
							.append(submitBtnBottom);
					}
					navTabs.append(ui.$$.li().append(demandTab));
				}

				navTabs.children('li').first().addClass('active');
				navContent.children('.tab-pane').first().addClass('in active');

				const formBody = new ui.Box.Box().addClass('nav address-object-nav')
					.append(navTabs)
					.append(navContent);

				return formBody.Root();
			}

			private onDemandFormSave(e: JQuery.Event)
			{
				e.preventDefault();

				// Save button outside of form
				// let form = $(e.target).parent().find('form');
				let form = $('form.contact-needs.row');
				// Or Save button is part of the form
				if (form.length === 0)
				{
					form = $(e.target).closest('form');
				}
				const formData = form.serializeArray();

				// Form to object conversion
				const obj: {[key: string]: any} = {};

				for (const entry of formData) {
					entry.name = entry.name.replace('demand.', '');

					const parts: string[] = entry.name.split('.');

					let subObj = obj;
					while (parts.length > 1) {
						const part = parts.shift();
						if (part === undefined)
						{
							break;
						}

						if (subObj[part] === undefined) {
							subObj[part] = {};
						}

						subObj = subObj[part];
					}
					const prop = parts[0];
					if (subObj[prop] === undefined) {
						subObj[prop] = entry.value;
					} else {
						if (false === (subObj[prop] instanceof Array)) {
							subObj[prop] = [subObj[prop]];
						}
						subObj[prop].push(entry.value);
					}
				}
				const data: any = {};
				data.needs = obj;

				app.getContactManager().saveDemand(e.data.contact.ContactID, data);
			}

			private onDetailFormSave(e: JQuery.Event)
			{
				e.preventDefault();

				// Save button outside of form
				let form = $(e.target).parent().find('form');
				// Or Save button is part of the form
				if (form.length === 0) {
					form = $(e.target).closest('form');
				}
				const formData = form.serializeArray();

				// Form to object conversion
				const obj = {};
				for (const entry of formData) {
					entry.name = entry.name.replace('demand.', '');

					const parts = entry.name.split('.');

					let subObj: any = obj;
					while (parts.length > 1) {
						const part = parts.shift();
						if (subObj[part] === undefined) {
							subObj[part] = {};
						}

						subObj = subObj[part];
					}
					const prop = parts[0];
					if (subObj[prop] === undefined) {
						subObj[prop] = entry.value;
					} else {
						if (false === (subObj[prop] instanceof Array)) {
							subObj[prop] = [subObj[prop]];
						}
						subObj[prop].push(entry.value);
					}
				}

				app.getContactManager().saveDetails(this.Contact.ContactID, obj);
			}

			private buildDemandSummary(contact: SPA.Contact): JQuery
			{
				let demand: any;
				if (contact.Demand === null) {
					demand = [];
				} else {
					demand = contact.Demand.needs ? contact.Demand.needs : [];
				}
				const quickInfoView = new SelfinfoView({model: contact});

				const html = $('<form class="contact-needs">').addClass('row')
					.append(ui.$$.div().addClass('col-xs-12')
						.append('<h2>Bedarfsanalyse</h2>')
						.append(`
						<span style="display: inline-block;min-width: 90px">Haustyp</span>
						<label>
							<input type="checkbox" name="demand.type" value="efh" ${demand.type && (demand.type === 'efh' || _.contains(demand.type, 'efh')) ? 'checked' : ''} />
							<span>Einfamilienhaus</span>
						</label>
						<label>
							<input type="checkbox" name="demand.type" value="mfh" ${demand.type && (demand.type === 'mfh' || _.contains(demand.type, 'mfh')) ? 'checked' : ''} />
							<span>Mehrfamilienhaus</span>
						</label>
						<label>
							<input type="checkbox" name="demand.type" value="dhh" ${demand.type && (demand.type === 'dhh' || _.contains(demand.type, 'dhh')) ? 'checked' : ''} />
							<span>Doppelhaushälfte</span>
						</label>
						<label>
							<input type="checkbox" name="demand.type" value="etw" ${demand.type && (demand.type === 'etw' || _.contains(demand.type, 'etw')) ? 'checked' : ''} />
							<span>Eigentumswohnung</span>
						</label>
						<label>
							<input type="checkbox" name="demand.type" value="gs" ${demand.type && (demand.type === 'gs' || _.contains(demand.type, 'gs')) ? 'checked' : ''} />
							<span>Grundstück</span>
						</label>
						<div class="hspacer"></div>
						<span style="display: inline-block;min-width: 90px">Zustand</span>
						<label>
							<input type="checkbox" name="demand.condition" value="new" ${demand.condition && (demand.condition === 'new' || _.contains(demand.condition, 'new')) ? 'checked' : ''} />
							<span>Neubau</span>
						</label>
						<label>
							<input type="checkbox" name="demand.condition" value="old_rehab" ${demand.condition && (demand.condition === 'old_rehab' || _.contains(demand.condition, 'old_rehab')) ? 'checked' : ''} />
							<span>Altbau saniert</span>
						</label>
						<label>
							<input type="checkbox" name="demand.condition" value="old_renovation" ${demand.condition && (demand.condition === 'old_renovation' || _.contains(demand.condition, 'old_renovation')) ? 'checked' : ''} />
							<span>Altbau renovierungsbedürftig</span>
						</label>
						<div class="hspacer"></div>
						<span style="display: inline-block;min-width: 90px">Objektstil</span>
						<label>
							<input type="checkbox" name="demand.style" value="modern" ${demand.style && (demand.style === 'modern' || _.contains(demand.style, 'modern')) ? 'checked' : ''} />
							<span>modern</span>
						</label>
						<label>
							<input type="checkbox" name="demand.style" value="classic" ${demand.style && (demand.style === 'classic' || _.contains(demand.style, 'classic')) ? 'checked' : ''} />
							<span>klassisch</span>
						</label>
						`)
					)
					.append(ui.$$.div().addClass('col-xs-12')
						.append(`
						<div class="hspacer"></div>
						Im Umkreis von <input type="text" name="demand.range" value="${demand.range || ''}" size="5"> km
						der Stadt <input type="text" name="demand.city" value="${demand.city || ''}" size="20">.
						<div class="hspacer"></div>
						Die Gesamtwohnfläche soll mindestens <input type="text" name="demand.wf.min" value="${demand.wf ? demand.wf.min : ''}" size="5"> m²,
						höchstens aber <input type="text" name="demand.wf.max" value="${demand.wf ? demand.wf.max : ''}" size="5"> m² betragen.
						<div class="hspacer"></div>
						Die Gesamtgrundstücksgröße soll mindestens <input type="text" name="demand.gs.min" value="${demand.gs ? demand.gs.min : ''}" size="5"> m²,
						höchstens aber <input type="text" name="demand.gs.max" value="${demand.gs ? demand.gs.max : ''}" size="5"> m² betragen.
						<div class="hspacer"></div>
						<div class="hspacer"></div>
						`)
					);

				return html;
			}

			private buildDemandForm(contact: SPA.Contact): JQuery
			{
				let demand: any;
				if (contact.Demand === null) {
					demand = [];
				} else {
					demand = contact.Demand.needs ? contact.Demand.needs : [];
				}
				const html = this.buildDemandSummary(contact)
					.append(ui.$$.div().addClass('col-xs-12')
						.append(`
						<div class="row">
							<div class="col-xs-6">
								<h3>Personenanzahl</h3>
								<div class="demand-person">
									<label>
										<input type="checkbox" name="demand.family.one.active" value="1" ${demand.family && demand.family.one.active ? 'checked' : ''}>
										<span>Eine Familie</span>
									</label>
									<input type="text" name="demand.family.one.count" value="${demand.family ? demand.family.one.count : ''}" size="5">
									<span>Personen</span>
									<div class="hspacer"></div>
									<label>
										<input type="checkbox" name="demand.family.two.active" value="1" ${demand.family && demand.family.two.active ? 'checked' : ''}>
										<span>Zwei Familien</span>
									</label>
									<input type="text" name="demand.family.two.count" value="${demand.family ? demand.family.two.count : ''}" size="5">
									<span>Personen</span>
									<div class="hspacer"></div>
									<label>
										<input type="checkbox" name="demand.family.multi.active" value="1" ${demand.family && demand.family.multi.active ? 'checked' : ''}>
										<span>Mehrgenerationen</span>
									</label>
									<input type="text" name="demand.family.multi.count" value="${demand.family ? demand.family.multi.count : ''}" size="5">
									<span>Personen</span>
								</div>
								<div class="hspacer"></div>
								<label>Notizen</label>
								<textarea class="form-control" name="demand.family.text">${demand.family ? demand.family.text : ''}</textarea>
							</div>
							<div class="col-xs-6">
								<h3>Zimmeranzahl</h3>
								<input type="text" name="demand.rooms.bed" value="${demand.rooms ? demand.rooms.bed : ''}" size="5">
								<label>Schlafzimmer</label>
								<div class="hspacer"></div>
								<input type="text" name="demand.rooms.guest" value="${demand.rooms ? demand.rooms.guest : ''}" size="5">
								<label>Gästezimmer</label>
								<div class="hspacer"></div>
								<input type="text" name="demand.rooms.work" value="${demand.rooms ? demand.rooms.work : ''}" size="5">
								<label>Arbeitszimmer</label>
								<div class="hspacer"></div>
								<input type="text" name="demand.rooms.hobby" value="${demand.rooms ? demand.rooms.hobby : ''}" size="5">
								<label>Werkstatt/Hobbyraum</label>
								<div class="hspacer"></div>
								<label>Notizen</label>
								<textarea class="form-control" name="demand.rooms.text">${demand.rooms ? demand.rooms.text : ''}</textarea>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-6">
								<h3>Nutzflächenbedarf</h3>
								<label>
									<input type="checkbox" name="demand.nf.lumber.active" value="1" ${demand.nf && demand.nf.lumber.active ? 'checked' : ''}>
									<span>Abstellkammer</span>
								</label>
								<input type="text" name="demand.nf.lumber.size" value="${demand.nf ? demand.nf.lumber.size : ''}" size="5">
								<span>m²</span>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.nf.utility.active" value="1" ${demand.nf && demand.nf.utility.active ? 'checked' : ''}>
									<span>Hauswirtschaftsraum</span>
								</label>
								<input type="text" name="demand.nf.utility.size" value="${demand.nf ? demand.nf.utility.size : ''}" size="5">
								<span>m²</span>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.nf.cellar.active" value="1" ${demand.nf && demand.nf.cellar.active ? 'checked' : ''}>
									<span>Keller</span>
								</label>
								<input type="text" name="demand.nf.cellar.size" value="${demand.nf ? demand.nf.cellar.size : ''}" size="5">
								<span>m²</span>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.nf.garage.active" value="1" ${demand.nf && demand.nf.garage.active ? 'checked' : ''}>
									<span>Garage mit zusätzlicher Nutzfläche</span>
								</label>
								<input type="text" name="demand.nf.garage.size" value="${demand.nf ? demand.nf.garage.size : ''}" size="5">
								<span>m²</span>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.nf.summer.active" value="1" ${demand.nf && demand.nf.summer.active ? 'checked' : ''}>
									<span>Gartenhaus/Geräteschuppen</span>
								</label>
								<input type="text" name="demand.nf.summer.size" value="${demand.nf ? demand.nf.summer.size : ''}" size="5">
								<span>m²</span>
								<div class="hspacer"></div>
								<label>Notizen</label>
								<textarea class="form-control" name="demand.nf.text">${demand.nf ? demand.nf.text : ''}</textarea>
							</div>
							<div class="col-xs-6">
								<h3>Anzahl Badezimmer</h3>
								<input type="text" name="demand.bath.tub.count" value="${demand.bath ? demand.bath.tub.count : ''}" size="5">
								<label>Badezimmer mit Badewanne</label>
								<div class="hspacer"></div>
								<input type="text" name="demand.bath.shower.count" value="${demand.bath ? demand.bath.shower.count : ''}" size="5">
								<label>Dusch-Badezimmer</label>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.bath.wellness.active" value="1" ${demand.bath && demand.bath.wellness && demand.bath.wellness.active ? 'checked' : ''}>
									<span>Wellnessbereich (z.B. Sauna)</span>
								</label>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.bath.guest.active" value="1" ${demand.bath && demand.bath.guest && demand.bath.guest.active ? 'checked' : ''}>
									<span>Gäste-WC</span>
								</label>
								<div class="hspacer"></div>
								<label>Notizen</label>
								<textarea class="form-control" name="demand.bath.text">${demand.bath ? demand.bath.text : ''}</textarea>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-6">
								<h3>Outdoor Bedarf</h3>
								<div class="demand-outdoor">
									<label>
										<input type="checkbox" name="demand.outdoor.balcony.active" value="1" ${demand.outdoor && demand.outdoor.balcony.active ? 'checked' : ''}>
										<span>Balkon</span>
									</label>
									<input type="text" name="demand.outdoor.balcony.size" value="${demand.outdoor ? demand.outdoor.balcony.size : ''}" size="5">
									<span>m²</span>
									<div class="hspacer"></div>
									<label>
										<input type="checkbox" name="demand.outdoor.roofdeck.active" value="1" ${demand.outdoor && demand.outdoor.roofdeck.active ? 'checked' : ''}>
										<span>Dachterrasse</span>
									</label>
									<input type="text" name="demand.outdoor.roofdeck.size" value="${demand.outdoor ? demand.outdoor.roofdeck.size : ''}" size="5">
									<span>m²</span>
									<div class="hspacer"></div>
									<label>
										<input type="checkbox" name="demand.outdoor.terrace.active" value="1" ${demand.outdoor && demand.outdoor.terrace.active ? 'checked' : ''}>
										<span>Garten-Terrasse</span>
									</label>
									<input type="text" name="demand.outdoor.terrace.size" value="${demand.outdoor ? demand.outdoor.terrace.size : ''}" size="5">
									<span>m²</span>
									<div class="hspacer"></div>
									<label>
										<input type="checkbox" name="demand.outdoor.garden.active" value="1" ${demand.outdoor && demand.outdoor.garden.active ? 'checked' : ''}>
										<span>Garten</span>
									</label>
									<input type="text" name="demand.outdoor.garden.size" value="${demand.outdoor ? demand.outdoor.garden.size : ''}" size="5">
									<span>m²</span>
									<div class="hspacer"></div>
									<label>
										<input type="checkbox" name="demand.outdoor.frontgarden.active" value="1" ${demand.outdoor && demand.outdoor.frontgarden.active ? 'checked' : ''}>
										<span>Vorgarten</span>
									</label>
									<input type="text" name="demand.outdoor.frontgarden.size" value="${demand.outdoor ? demand.outdoor.frontgarden.size : ''}" size="5">
									<span>m²</span>
								</div>
								<div class="hspacer"></div>
								<label>Notizen</label>
								<textarea class="form-control" name="demand.outdoor.text">${demand.outdoor ? demand.outdoor.text : ''}</textarea>
							</div>
							<div class="col-xs-6">
								<h3>Stellplatz Bedarf</h3>
								<input type="text" name="demand.parking.count" value="${demand.parking ? demand.parking.count : ''}" size="5">
								<label>Fahrzeuge</label>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.parking.option" value="garage" ${demand.parking && (demand.parking === 'garage' || _.contains(demand.parking.option, 'garage')) ? 'checked' : ''}>
									<span>Garage</span>
								</label>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.parking.option" value="space" ${demand.parking && (demand.parking === 'space' || _.contains(demand.parking.option, 'space')) ? 'checked' : ''}>
									<span>Stellplatz</span>
								</label>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.parking.option" value="carport" ${demand.parking && (demand.parking === 'carport' || _.contains(demand.parking.option, 'carport')) ? 'checked' : ''}>
									<span>Carport</span>
								</label>
								<div class="hspacer"></div>
								<label>
									<input type="checkbox" name="demand.parking.option" value="street" ${demand.parking && (demand.parking === 'street' || _.contains(demand.parking.option, 'street')) ? 'checked' : ''}>
									<span>Parken an der Straße</span>
								</label>
								<div class="hspacer"></div>
								<label>Notizen</label>
								<textarea class="form-control" name="demand.parking.text">${demand.parking ? demand.parking.text : ''}</textarea>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<h3>Barrierefreies Wohnen</h3>
								<div class="demand-accessible">
									<label>
										<input type="checkbox" name="demand.accessible.option" value="flat" ${demand.accessible && (demand.accessible === 'flat' || _.contains(demand.accessible.option, 'flat')) ? 'checked' : ''}>
										<span>Wohnen auf einer Ebene ohne Treppen</span>
									</label>
									<label>
										<input type="checkbox" name="demand.accessible.option" value="ramp" ${demand.accessible && (demand.accessible === 'ramp' || _.contains(demand.accessible.option, 'ramp')) ? 'checked' : ''}>
										<span>Auffahrrampe für Rollstuhlfahrer</span>
									</label>
									<label>
										<input type="checkbox" name="demand.accessible.option" value="passage" ${demand.accessible && (demand.accessible === 'passage' || _.contains(demand.accessible.option, 'passage')) ? 'checked' : ''}>
										<span>Breite Türdurchgänge</span>
									</label>
									<label>
										<input type="checkbox" name="demand.accessible.option" value="toilet" ${demand.accessible && (demand.accessible === 'toilet' || _.contains(demand.accessible.option, 'toilet')) ? 'checked' : ''}>
										<span>Barrierefreies WC/ Badezimmer</span>
									</label>
									<label>
										<input type="checkbox" name="demand.accessible.option" value="elevator" ${demand.accessible && (demand.accessible === 'elevator' || _.contains(demand.accessible.option, 'elevator')) ? 'checked' : ''}>
										<span>Aufzug</span>
									</label>
									<label>
										<input type="checkbox" name="demand.accessible.option" value="lift" ${demand.accessible && (demand.accessible === 'lift' || _.contains(demand.accessible.option, 'lift')) ? 'checked' : ''}>
										<span>Treppenlift</span>
									</label>
								</div>
								<div class="hspacer"></div>
								<label>Notizen</label>
								<textarea class="form-control" name="demand.accessible.text">${demand.accessible ? demand.accessible.text : ''}</textarea>
							</div>
						</div>
`)
					);

				return html;
			}
		}
	}
}
